// FUNCTION TO LOCK NAVIGATION
export function lockScreenScroll() {
  const elementsDOM = document.querySelector('body, html');
  const lockScreen = document.querySelector('.lock-screen');

  elementsDOM.classList.toggle('scroll-lock');
  lockScreen.classList.toggle('d-flex');
}
